module.exports = __webpack_public_path__ + "static/media/400020_01.c9d5648a.png";